import { AddButton, Button, CloseButton } from '@ui/shared/Button';
import isEmpty from 'lodash/isEmpty';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import {
  closeInnerPopup,
  openInnerPopup,
} from '../../../data/providers/popupsProvider';
import { addTag } from '../../../data/writers/tags';
import { CardBody } from '../../shared/card/CardBody';
import {
  CardFooter,
  CardFooterLeft,
  CardFooterRight,
} from '../../shared/card/CardFooter';
import {
  CardHeader,
  CardHeaderLeft,
  CardHeaderRight,
} from '../../shared/card/CardHeader';
import {
  InnerPopupCard,
  PopupCardContent,
} from '../../shared/popups/PopupCard';
import { TagForm } from './TagForm';

export const AddTag = withRouter(
  (props: RouteComponentProps): React.ReactElement => {
    /**
     * @description opens add tag popup
     */
    const openDialog = (): void =>
      openInnerPopup(
        <AddTagPopupCard onClose={closeInnerPopup(props.history)} />,
        props.history,
        'add'
      );

    return <AddButton onClick={openDialog} />;
  }
);

interface IAddTagProps {
  onClose: () => void;
}

const AddTagPopupCard = (props: IAddTagProps): React.ReactElement => {
  const [name, setName] = React.useState<string>();
  const [description, setDescription] = React.useState<string>();
  const [excludeWeight, setExcludeWeight] = React.useState<boolean>(false);

  const toggleExcludeWeight = (): void => setExcludeWeight(!excludeWeight);

  const saveTag = (): void => {
    addTag({
      name,
      description: description || '',
      exclude_weight: excludeWeight,
      exclude_aggregates: false,
      default: false,
      active: true,
    });
    props.onClose();
  };

  return (
    <InnerPopupCard onClose={props.onClose} size='medium' noClickOutside>
      <PopupCardContent>
        <CardHeader surface={8}>
          <CardHeaderLeft>
            <h5>Add New Tag</h5>
          </CardHeaderLeft>
          <CardHeaderRight>
            <CloseButton onClick={props.onClose} />
          </CardHeaderRight>
        </CardHeader>
        <CardBody style={{ padding: '20px' }}>
          <TagForm
            tag={{
              name,
              description,
              exclude_weight: excludeWeight,
            }}
            updateName={setName}
            updateDesc={setDescription}
            toggle={toggleExcludeWeight}
          />
        </CardBody>
        <CardFooter surface={8}>
          <CardFooterLeft />
          <CardFooterRight>
            <Button
              disabled={!name || isEmpty(name)}
              onClick={saveTag}
              type='submit'
              title='Add Tag'
              icon='add'
              style={{ whiteSpace: 'nowrap' }}
            />
          </CardFooterRight>
        </CardFooter>
      </PopupCardContent>
    </InnerPopupCard>
  );
};
